import { IonContent, IonPage } from '@ionic/react';
import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { Controller, Navigation, Pagination, Zoom } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import Toolbar2 from '../../layouts/Toolbar2';

import './Gallery.css';
import 'swiper/swiper.min.css';
import 'swiper/modules/zoom/zoom.min.css';
import 'swiper/modules/pagination/pagination.min.css';
import 'swiper/modules/controller/controller.min.css';

const Gallery: React.FC = () => {
    const history = useHistory();

    const [firstSwiper, setFirstSwiper] = useState(null as any);
    const [secondSwiper, setSecondSwiper] = useState(null as any);

    return <IonPage className='gallery'>
        <Toolbar2 title="" hasBackButton transparent />

        <IonContent>
            <Swiper
                modules={[Controller, Pagination, Zoom]}
                zoom={true}
                dir="ltr"
                initialSlide={(history.location.state as any)?.index!}
                pagination={{ clickable: true }}>
                {
                    (history.location.state as any)?.images?.map((item: any) => {
                        console.log(item);
                        
                        return <SwiperSlide zoom>
                            <img src={item.url} />
                        </SwiperSlide>
                    })
                }
            </Swiper>
        </IonContent>
    </IonPage>
}

export default Gallery